export class MetaStruct {
    constructor({ id, key, value, type, objectSchema, pattern, hint, integration_id }) {
        this.id = id || '';
        this.key = key || '';
        this.value = value || '';
        this.type = type || 'string';
        this.objectSchema = objectSchema || null;
        this.pattern = pattern || null;
        this.hint = hint || null;
        this.integration_id = integration_id || null;
    }
}